/**
 * 공지사항 목록
 */
import React, { Component } from 'react';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading } from '../../common/common';
import { Link } from 'react-router-dom';
import { Navbar, ListGroup, Col, Row, Badge } from 'react-bootstrap';
import $ from 'jquery';
import loader from '../../imgs/ajax-loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faChevronRight, faPlusCircle, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { dropByCacheKey } from 'react-router-cache-route'

let isLogging = false;
let isMore = true;
let isRunning = false;
let recordCountPerPage = 15;	// 한번에 불러 올 레코드 개수

class NoticeCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstIndex: 0,	// 불러 올 시작 레코드

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      list: [],
      usrInfo: null,
    }

    props.cacheLifecycles.didCache(this.componentDidCache)
    props.cacheLifecycles.didRecover(this.componentDidRecover)
  }

  // 스크롤 위치 기억
  scrollPostion = 0;

  // 본 페이지를 떠날때 캐시 저장후 이벤트
  componentDidCache = () => {
    // 케시된 페이지 DROP
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');

    // 스크롤 이벤트 해제
    window.removeEventListener('scroll', this.handleScroll);
  }

  // 케시된 페이지로 바로 다시 돌아 왔을때 캐시 내용 복원 후 이벤트
  componentDidRecover = () => {
    if (isMore && !isRunning && !isLogging) {
      isLogging = true;
      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        if (data !== null && data.userSe === 'STDT') {
          this.props.history.push('/stdt/ruleList');
        } else if (data !== null && data.userSe === 'USR') {
          isLogging = false;
          this.setState({ usrInfo: data });
        } else {
          this.props.history.push('/');
        }
      });
    }

    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('noticeSchoolCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');

    // 스크롤 이벤트 바인딩
    window.addEventListener('scroll', this.handleScroll);

    // 스크롤 위치 복원
    $(window).scrollTop(this.scrollPostion);
    udfNoneLoading();
  }

  componentDidMount = () => {
    if (isMore && !isRunning && !isLogging) {
      isLogging = true;
      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        if (data !== null && data.userSe === 'STDT') {
          this.props.history.push('/stdt/ruleList');
        } else if (data !== null && data.userSe === 'USR') {
          isLogging = false;
          this.setState({ usrInfo: data });
          this.udfSelectlist('Y');
        } else {
          this.props.history.push('/');
        }
      });
    }

    this.isMore = true;
    this.isRunning = false;

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // 스크롤 위치 기억
    this.scrollPostion = $(window).scrollTop();

    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0 || $('.modal-backdrop.show').length > 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && this.isMore) {
      this.udfSelectlist('N');
    }
  }

  udfSelectlist = (clearYn) => {
    if (!this.state.usrInfo || isLogging) return;

    if (clearYn === 'Y') $(window).scrollTop(0);

    const that = this;
    if (this.isMore && !this.isRunning) {
      udfInlineLoading();
      this.isRunning = true;

      let setData = {
        isMobile: 'Y',
        firstIndex: (clearYn === 'Y') ? 0 : this.state.firstIndex,
        recordCountPerPage: recordCountPerPage,
        bbsId: that.props.match.params.bbsId
      };

      $.ajax({
        url: url + '/cop/bbs/selectBoardList.do',
        type: 'GET',
        dataType: 'jsonp',
        data: setData,
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            if (data.list !== undefined && data.list !== null) {
              if (data.list.length !== recordCountPerPage)
                that.isMore = false;

              that.setState({
                firstIndex: that.state.firstIndex + data.list.length,
                isLoggedIn: true,
                list: that.state.list.concat(data.list)
              });
            }
          }
          that.isRunning = false;
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          that.componentDidMount();
          udfNoneLoading();
        }
      });
    }
  }

  render() {
    const list = this.props.match == null || this.state.list === null ? null :
      this.state.list.map((data, idx) => {
        if (data.useAt !== 'N') {
          let linkUrl = '/usr/noticeArticle/' + this.props.match.params.bbsId + '/' + data.nttId;
          return (
            <Link to={linkUrl} key={idx}>
              <ListGroup.Item>
                <Row>
                  <Col>
                    {this.props.match.params.bbsId === 'BBSMSTR_000000000021' && data.useAt !== 'N' ?
                      (data.CMT_CNT !== '0' ? <Badge variant="success" className="mr-2">답변완료</Badge> : <Badge variant="danger" className="mr-2">답변대기</Badge>)
                      : ''}
                    {data.nttSj}
                    <div style={{ fontSize: '.9rem', color: 'gray' }}>{data.frstRegisterPnttm}</div>
                  </Col>
                  <Col style={{ maxWidth: '50px', textAlign: 'right' }}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </Col>
                </Row>
              </ListGroup.Item>
            </Link>
          );
        } else return null;
      });
    return this.props.match ? (
      <>
        {
          this.props.match.params.bbsId === 'BBSMSTR_000000000021' ?
            <>
              {/* to the top */}
              <div className='btn-to-top' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>
              <Link to='/usr/noticeRegist/BBSMSTR_000000000021/0'>
                <div className='btn-rule-add'><FontAwesomeIcon icon={faPlusCircle} /></div>
              </Link>
            </>
            : <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>
        }
        <div className='wrap-loading'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          {this.props.match.params.bbsId === 'BBSMSTR_000000000001' ? '공지사항' :
            this.props.match.params.bbsId === 'BBSMSTR_000000000021' ? '1:1상담' :
              this.props.match.params.bbsId === 'BBSMSTR_000000000011' ? '업데이트 소식' :
                this.props.match.params.bbsId === 'BBSMSTR_000000000002' ? '학교게시물' : ''}
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <ListGroup variant='flush' style={{ marginTop: '55px', marginBottom: '4rem' }}>
          {list}
        </ListGroup>
      </>
    ) : <></>;
  }
}

export default NoticeCmp;